<template>  
  <v-layout row wrap style="position: relative;">
   <v-flex xs12 class="flex-container" >
      <mission-detail-rsync :mission="mission" />      
    </v-flex>   
     <v-flex xs12 class="flex-container" >
      <mission-detail-ftp :mission="mission" />      
    </v-flex>      
     <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>  
  </v-layout>
</template>

<script lang="ts">
  import Vue from 'vue'
  //@ts-ignore
  import Component from 'vue-class-component'
  import deepEqual from 'deep-equal'  
  import { Watch} from 'vue-property-decorator'    
  import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer';
  import { IFtpConfig } from '@/models/iris/ftp/IFtpConfig';
  import MissionDetailFtp from '@/components/mission/MissionDetailFtp.vue'
  import MissionDetailRsync from '@/components/mission/MissionDetailRsync.vue'
  import { AloMission } from '@/models/alo/AloMission';




  @Component({
    name: 'MissionDetailFtpRsync',        
    components:{MissionDetailFtp,MissionDetailRsync},
    props:{
       mission: AloMission
    }
  })
  export default class MissionDetailFtpRsync extends Vue {

    mission!:AloMission

    get loading(){
      return this.$store.myGetters.ftpLoading || this.$store.myGetters.rsyncLoading
    }

    get status(){
      return this.$store.myGetters.gliderStatus
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  
  
  .flex-container{
    display:flex;
    flex-direction:column;
    position:relative;    
  }

</style>
